const indexItems = [
  { title: '蜜桃视频独家推荐', desc: '每月精选蜜桃视频最受关注的独家内容合集', icon: 'ri-heart-line', color: 'accent' },
  { title: '红桃视频编辑力荐', desc: '红桃视频编辑团队精心筛选的高分作品专题', icon: 'ri-star-line', color: 'primary' },
  { title: '香蕉视频VIP免费频道', desc: '香蕉视频VIP会员专属内容免费开放合集', icon: 'ri-vip-crown-line', color: 'primary' },
  { title: '樱花视频新番速递', desc: '樱花视频频道最新番剧与热门内容一网打尽', icon: 'ri-fire-line', color: 'accent' },
  { title: '全站热播排行榜', desc: '基于多维度数据综合计算的全站热播TOP榜单', icon: 'ri-bar-chart-line', color: 'secondary' },
  { title: '独家策划专题系列', desc: '日皮视频团队深度策划的原创专题内容', icon: 'ri-lightbulb-line', color: 'primary' },
  { title: '高清专区精选', desc: '精选高清画质优质内容，流畅不缓冲观影体验', icon: 'ri-4k-line', color: 'secondary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            专题索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            快速导航到蜜桃视频、红桃视频、香蕉视频与樱花视频等全频道专题内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => {
            const isAccent = item.color === 'accent';
            const isPrimary = item.color === 'primary';
            const bgClass = isAccent
              ? 'bg-accent-100/10 border-accent-300/20 hover:border-accent-300/40'
              : isPrimary
              ? 'bg-primary-100/10 border-primary-300/20 hover:border-primary-300/40'
              : 'bg-secondary-100/10 border-secondary-300/20 hover:border-secondary-300/40';
            const iconClass = isAccent
              ? 'text-accent-400'
              : isPrimary
              ? 'text-primary-400'
              : 'text-secondary-400';
            return (
              <a
                key={item.title}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`flex items-start gap-4 p-5 rounded-xl border transition-all duration-200 cursor-pointer ${bgClass}`}
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg bg-background-100">
                  <i className={`${item.icon} text-xl ${iconClass}`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}